import { IElementToSimpleSapElementMapperFactory } from '../IElementToSimpleSapElementMapperFactory';
import Element, { ElementType } from '@/models/element';
import { IElementToSimpleSamElementsMapper } from '../elementToSimpleSapElementsMapper';
import { NullToSimpleSapELementMapper } from '../nullToSimpleSapElementMapper';
import { TableLegsToSimpleSapElementMapper } from './tableLegsToSimpleSapElementMapper';
import { TableBodyToSimpleSapElementMapper } from './tableBodyToSimpleSapElementMapper';

export class TableElementToSimpleSapElementMapperFactory
    implements IElementToSimpleSapElementMapperFactory {

    private body = new TableBodyToSimpleSapElementMapper();
    private legs = new TableLegsToSimpleSapElementMapper();
    private null = new NullToSimpleSapELementMapper();

    public getMapperFor(element: Element): IElementToSimpleSamElementsMapper {
        if (element.type === ElementType.BODY) {
            return this.body;
        }
        if (element.type === ElementType.LEGS) {
            return this.legs;
        }
        return this.null;
    }
}